module.exports = __webpack_public_path__ + "deac1d4aa2ccf7ed832e4db55bb64e63.png";